'use es6';

import { RECEIVED_SETTINGS, REQUESTED_SETTINGS_FAILED, REQUESTED_SETTINGS } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
import Settings from '../models/Settings';
export default ((state = new Settings(), action) => {
  switch (action.type) {
    case REQUESTED_SETTINGS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_SETTINGS:
      return action.payload.settings;
    case REQUESTED_SETTINGS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});